<template>
  <ul class="password-errors">
    <li
      v-for="(validation, index) in errorValidations"
      :id="validation.name + '-validation'"
      :key="'error' + index"
      :class="{ 'password-errors--passed': !hasError(validation.message) }"
    >
      <span
        :class="[
          { 'password-errors-status--passed': !hasError(validation.message) },
          'password-errors-status',
        ]"
      >
      </span>
      {{ validation.message }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PasswordValidation',
  props: ['password', 'isValid'],
  data() {
    return {
      errorValidations: [
        {
          name: 'lowercase',
          regex: /^(?=.*[a-z])/,
          message: 'At least one lowercase letter',
        },
        {
          name: 'uppercase',
          regex: /^(?=.*[A-Z])/,
          message: 'At least one uppercase letter',
        },
        {
          name: 'number',
          regex: /^(?=.*[0-9])/,
          message: 'At least one number',
        },
        {
          name: 'special',
          regex: /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~`])/,
          message: 'At least one special character',
        },
        {
          name: 'length',
          regex: /^(.{10,72})/,
          message: 'At least 10 characters',
        },
      ],
    }
  },
  computed: {
    passwordErrors() {
      return this.errorValidations.filter((validation) => {
        return !validation.regex.test(this.password)
      })
    },
  },
  watch: {
    passwordErrors() {
      if (this.isValid !== undefined) {
        const _isValid = this.passwordErrors.length === 0
        this.$emit('update:is-valid', _isValid)
      }
    },
  },
  methods: {
    hasError(errorMessage) {
      return this.passwordErrors.some((validation) => {
        return validation.message === errorMessage
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.password-errors {
  margin: 1em 0;
  font-size: $small-font;
  text-align: left;
  padding: 0;
  list-style-type: none;
  color: $black;
  &--passed {
    color: $grey-text;
    font-weight: 200;
  }
  &-status {
    height: $tiny-font;
    width: $tiny-font;
    background-color: $off-white;
    border-radius: 50%;
    display: inline-block;
    margin-right: 1em;
    &--passed {
      background-color: $green;
    }
  }
}
</style>
